import Vue from 'vue'
import VueRouter from 'vue-router'
import VuePapaParse from 'vue-papa-parse'
import VueMediaEmbed from 'vue-media-embed'
import Vuex from 'vuex'
import App from '@/App'
import Routes from '@/routes/Routes'
import LoadScript from 'vue-plugin-load-script'
import imgView from 'vue-img-view'
import '@/assets/styles/tailwind.css';
import '@/assets/styles/styles.css';

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(LoadScript)
Vue.use(VuePapaParse)
Vue.use(Vuex)
const store = new Vuex.Store({ })
Vue.use(VueMediaEmbed, { store })
Vue.use(imgView)


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: Routes
})

router.beforeEach((to, from, next) => {
//  console.log("router.beforeEach")
//  console.log(from)
//  console.log(to)

  if(to.matched[0].components.default.name){
    document.title = to.matched[0].components.default.name;
  } else{
    document.title = "SkillPills"
  }

  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
